if (typeof document === "undefined") return;
var createStylesheet = function(chunkId, fullhref, oldTag, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_components_project_globals_ModalMFA_ModalDefaultReset_vue":1,"chunk-common":1,"motherboard":1,"recipientsCreate":1,"TerminalDetails":1,"charges":1,"chargesdetail":1,"src_views_Account_Logs_vue":1,"src_views_Settings_AccountConfig_index_vue":1,"paymentmethods":1,"webhookconfigform":1,"Onboarding":1,"AppCoreHeader":1,"AppSidemenu":1,"AppCoreFooter":1,"src_views_Home_RefusalCodes_index_vue":1,"src_views_Home_Conversion_index_vue":1,"src_views_Recipients_RecipientsBiometry_RecipientsBiometry_vue":1,"src_views_PhysicalWorld_components_FormRollQuantity_vue":1,"src_views_PhysicalWorld_components_FormOpenHours_vue":1,"src_components_project_globals_ModalInfo_vue":1,"src_views_PhysicalWorld_components_ModalUninstallTerminal_vue":1,"datepicker/LogoPagarMe-vue":1,"datepicker/RangeDatepicker-vue":1,"src_components_project_globals_ModalChargeReprocess_vue":1,"src_views_Payments_Charges_PaymentMethod_index_vue":1,"src_views_Payments_Charges_Recipients_index_vue":1,"src_views_Payments_Charges_Recipients_BoletoCancel_index_vue":1,"src_views_Payments_Charges_TransactionSummary_index_vue":1,"src_views_Payments_Charges_TransactionTimeline_index_vue":1,"AppCoreHeaderLeft":1,"AppCoreHeaderRight":1,"src_components_project_ui_menu_AppMenu_AppMenuItem_vue":1,"src_components_project_ui_menu_AppMenu_AppMenuSubitems_vue":1,"src_components_project_ui_menu_AppMenu_AppMenuFooter_vue":1,"AccountsStatusAlertContainer":1,"src_components_project_globals_DashTimelineActivation_DashStepFinished_index_vue":1,"src_views_Recipients_RecipientsBiometry_biometry-status_PartiallyDenied_vue":1,"src_views_Recipients_RecipientsBiometry_GenerateLinkButton_vue":1,"src_views_PhysicalWorld_components_OpenHoursInput_vue":1,"src_views_PaymentLinks_Details_Infos_PaymentMethods_CreditCard_vue":1,"boleto":1,"src_views_Payments_Charges_TransactionDetails_DataOthersContainer_vue":1,"src_views_Account_Keys_modals_ModalCreateKey_CreateKey_vue":1,"src_views_Account_Keys_modals_ModalCreateKey_AllKey_vue":1,"src_views_Account_Keys_modals_ModalCreateKey_CustomKey_vue":1,"src_views_Recipients_RecipientsBiometry_biometry-status_StatusTemplate_vue":1,"src_views_Recipients_RecipientsBiometry_Spinner_vue":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded